"use client";

import { cn } from "@kyan/ui";
import { usePathname } from "next/navigation";
import { type ReactNode } from "react";

import { routes } from "#/config/routes";
import { useTopBannerFeatureFlag } from "#/hooks/featureFlags/useTopBannerFeatureFlag";

import { TradePanelAreaLimiter } from "../TradePanel/TradePanel";

interface WrapperProps {
  children: ReactNode;
}

export const Wrapper: React.FC<WrapperProps> = ({ children }) => {
  const { showTopBanner } = useTopBannerFeatureFlag();
  const pathname = usePathname();

  const isOnPortfolioPage = pathname.startsWith(routes.portfolio.index);

  return (
    <TradePanelAreaLimiter
      className={cn("flex-1 pt-20", {
        "pb-24": !isOnPortfolioPage,
        "pt-38": showTopBanner,
      })}
    >
      {children}
    </TradePanelAreaLimiter>
  );
};
